import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../../dotcom2024.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MyharrellsService } from '../../myharrells.service';

@Component({
  selector: 'app-knowledge',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './knowledge.component.html',
  styleUrl: './knowledge.component.css'
})
export class KnowledgeComponent implements OnInit {
  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Resources/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";
  imagePaths: string = environment.appDomainURL + environment.baseImagesFilePathBlobStorage + "/";
  imageExists: boolean = false;

  hasFilters: boolean = false;

  featuredPost: any;
  otherFeaturedPost1: any;
  otherFeaturedPost2: any;
  otherFeaturedPost3: any;

  disableMoreButton: boolean = false;

  topicsExpanded: boolean = true;

  showFilterObjects: boolean = false;

  filterFromQS: string = "";

  searchBlogsSubscription: Subscription;


  ngOnInit(): void {

    this.dotComService.activePage = "knowledge";

    this.dotComService.blogCategoriesSelected = "";
    this.dotComService.blogPagingStart = 0;
    this.GetMasterListOfPosts().then(() => {
      this.GetAllBlogCategories().then(() => {
        this.GetFeaturedBlog();
        this.GetOtherFeaturedBlogs();
        if (typeof document !== 'undefined' && document.location.search != '') {
          let queryString = document.location.search;
          let urlParams = new URLSearchParams(queryString);
          this.filterFromQS = urlParams.get('id');
          setTimeout(() => {
            (document.getElementById(this.filterFromQS) as HTMLInputElement).checked = true;
            this.dotComService.blogCategoriesSelected = this.filterFromQS
            this.hasFilters = true;

            //reload the grid
            this.dotComService.blogPagingStart = 0;
            this.GetMasterListOfPosts();
          }, 1);
        }
      })
    })
  }

  GetMasterListOfPosts() {
    return new Promise((resolve, reject) => {
      this.dotComService.resourceFilteredPosts = [];

      if (this.searchBlogsSubscription) {
        this.searchBlogsSubscription.unsubscribe();
      }

      this.searchBlogsSubscription = this.dotComService.GetAllActiveBlogs().subscribe((blogs) => {

        this.dotComService.resourceFilteredPosts = blogs;

        if (blogs.length == 0) {
          resolve(''); //should never happen
        }

        if (blogs.length < 3) {
          this.disableMoreButton = true;
        }

        for (let i = 0; i < this.dotComService.resourceFilteredPosts.length; i++) {
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            } else {
              // Fail code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
              this.dotComService.checkIfImageExists(this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.dotComService.resourceFilteredPosts[i].ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
          if (i == this.dotComService.resourceFilteredPosts.length - 1) {
            resolve('');
          }
        }
      })
    })
  }


  GetFeaturedBlog() {
    this.dotComService.GetFeaturedBlog().subscribe((blog) => {
      this.featuredPost = blog[0];
      //check for the correct image
      this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredPost.ItemAlias + ".jpg", (exists) => {
        if (exists) {
          // Success code
          this.featuredPost.ImageName = this.blogImagePaths + this.featuredPost.ItemAlias + ".jpg"
        } else {
          // Fail code
          this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredPost.ItemAlias + ".png", (exists) => {
            if (exists) {
              // Success code
              this.featuredPost.ImageName = this.blogImagePaths + this.featuredPost.ItemAlias + ".png"
            } else {
              // Fail code - use default
              this.featuredPost.ImageName = this.baseImagePaths + "harrellsh.png"
            }
          })
        }
      });
    })
  }

  GetOtherFeaturedBlogs() {
    this.dotComService.GetOtherFeaturedBlogs().subscribe((blogs) => {

      if (blogs.length < 3) {
        alert("At least one featured blog is missing.  Please contact support for assistance.")
      }



      this.otherFeaturedPost1 = blogs.filter(x => x.IsOtherFeaturedBlog1 == 1)
      this.otherFeaturedPost2 = blogs.filter(x => x.IsOtherFeaturedBlog2 == 1)
      this.otherFeaturedPost3 = blogs.filter(x => x.IsOtherFeaturedBlog3 == 1)

      //check for the correct image
      if (this.otherFeaturedPost1.length > 0) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost1[0].ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost1[0].ImageName = this.blogImagePaths + this.otherFeaturedPost1[0].ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost1[0].ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost1[0].ImageName = this.blogImagePaths + this.otherFeaturedPost1[0].ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost1[0].ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }

      //check for the correct image
      if (this.otherFeaturedPost2.length > 0) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost2[0].ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost2[0].ImageName = this.blogImagePaths + this.otherFeaturedPost2[0].ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost2[0].ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost2[0].ImageName = this.blogImagePaths + this.otherFeaturedPost2[0].ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost2[0].ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }

      //check for the correct image
      if (this.otherFeaturedPost3.length > 0) {
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost3[0].ItemAlias + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.otherFeaturedPost3[0].ImageName = this.blogImagePaths + this.otherFeaturedPost3[0].ItemAlias + ".jpg"
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.otherFeaturedPost3[0].ItemAlias + ".png", (exists) => {
              if (exists) {
                // Success code
                this.otherFeaturedPost3[0].ImageName = this.blogImagePaths + this.otherFeaturedPost3[0].ItemAlias + ".png"
              } else {
                // Fail code - use default
                this.otherFeaturedPost3[0].ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }
    })
  }


  GetAllBlogCategories() {
    return new Promise((resolve, reject) => {
      this.dotComService.blogCategories = [];
      this.dotComService.GetAllBlogCategories().subscribe((categories) => {
        this.dotComService.blogCategories = categories;
        resolve('');
      })
    })
  }

  // async GetFeaturedPost() {
  //   this.featuredPost = this.dotComService.resourceFilteredPosts.filter(y => y.IsFeaturedBlog == 1)
  //   //check for the correct image
  //   this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredPost[0].ItemAlias + ".jpg", (exists) => {
  //     if (exists) {
  //       // Success code
  //       this.featuredPost[0].ImageName = this.blogImagePaths + this.featuredPost[0].ItemAlias + ".jpg"
  //     } else {
  //       // Fail code
  //       this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredPost[0].ItemAlias + ".png", (exists) => {
  //         if (exists) {
  //           // Success code
  //           this.featuredPost[0].ImageName = this.blogImagePaths + this.featuredPost[0].ItemAlias + ".png"
  //         } else {
  //           // Fail code - use default
  //           this.featuredPost[0].ImageName = this.baseImagePaths + "harrellsh.png"
  //         }
  //       })
  //     }
  //   });
  // }

  GoToBlog(blog) {
    this.router.navigateByUrl('/blog?id=' + blog.ItemAlias);
  }

  BlogCategoryRadioChanged(row: any, e: Event): void {
    const target = e.target as HTMLInputElement;
    this.dotComService.blogCategoriesSelected = row

    if (this.dotComService.blogCategoriesSelected.length > 0) {
      this.hasFilters = true;
    }
    else {
      this.hasFilters = false;
    }

    //reload the grid
    this.dotComService.blogPagingStart = 0;
    this.GetMasterListOfPosts();
  }


  SearchBlogsFired(requestType?: string) {
    if (requestType == "all") {
      this.dotComService.blogSearchKey = "";
      for (let i = 0; i < this.dotComService.blogCategories.length; i++) {
        const element = this.dotComService.blogCategories[i];
        (document.getElementById(element.Category) as HTMLInputElement).checked = false;
      }

    }

    if (this.dotComService.blogSearchKey.length > 0) {
      this.hasFilters = true;
    }
    else {
      this.hasFilters = false;
    }


    this.dotComService.blogPagingStart = 0;
    this.GetMasterListOfPosts();
  }

  GetNextGroupOfBlogs() {
    //getting the next 3 blogs with same search criteria as previous 3
    this.dotComService.blogPagingStart = this.dotComService.blogPagingStart + 3

    this.dotComService.GetAllActiveBlogs().subscribe((blogs) => {
      //this.dotComService.resourceFilteredPosts = blogs;
      if (blogs.length == 0) {
        this.disableMoreButton = true;
      }
      else {
        for (let i = 0; i < blogs.length; i++) {
          if (blogs.length < 3) {
            this.disableMoreButton = true; //we got records but there are no more to get 
          }
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.blogImagePaths + blogs[i].ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              blogs[i].ImageName = this.blogImagePaths + blogs[i].ItemAlias + ".jpg"
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.blogImagePaths + blogs[i].ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  blogs[i].ImageName = this.blogImagePaths + blogs[i].ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  blogs[i].ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
          this.dotComService.resourceFilteredPosts.push(blogs[i]);
        }
      }
    })
  }

  ToggleExpand(groupToExpand: string) {
    if (groupToExpand == "Topics") {
      this.topicsExpanded = !this.topicsExpanded;

      if (this.topicsExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked
        //reload the grid
        this.hasFilters = false;
        this.dotComService.blogCategoriesSelected = "";
        this.dotComService.blogPagingStart = 0;
        this.GetMasterListOfPosts();
      }
    }
  }

  DisplayAllResources() {
    this.hasFilters = false;
    this.dotComService.blogSearchKey = "";
    this.dotComService.blogCategoriesSelected = "";
    this.dotComService.blogPagingStart = 0;
    this.GetMasterListOfPosts();
  }

  ToggleFilter() {
    this.showFilterObjects = !this.showFilterObjects;
  }
}
